import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'site-modules/shared/components/link/link';
import { useIsFramed } from 'site-modules/shared/hooks/use-is-framed';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { PageModel } from 'client/data/models/page';
import { buildAiAssistantUrl } from 'site-modules/shared/utils/ai-assistant-url';

const FrameProofLinkUI = memo(
  ({ location, children, className = '', ariaLabel = undefined, onClick = undefined, aiAssistantParams = {} }) => {
    const canvasUrl = buildAiAssistantUrl(location, aiAssistantParams);
    const isFramed = useIsFramed();

    return isFramed ? (
      <span className={className} aria-label={ariaLabel}>
        {children}
      </span>
    ) : (
      <Link
        to={canvasUrl}
        rel="nofollow"
        data-tracking-id="open_chat_canvas"
        data-tracking-ignore-value
        className={className}
        aria-label={ariaLabel}
        onClick={onClick}
      >
        {children}
      </Link>
    );
  }
);

FrameProofLinkUI.displayName = 'FrameProofLinkUI';
FrameProofLinkUI.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
  onClick: PropTypes.func,
  aiAssistantParams: PropTypes.shape({}),
};

export const FrameProofLink = connectToModel(FrameProofLinkUI, {
  location: bindToPath('location', PageModel, null, false),
});
